export default function HeroSection() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/1c1cc772eb0429a19fe5143ecedf89b1.jpg"
          alt="누수 전문가 출동"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-zinc-950/90 via-zinc-900/75 to-zinc-800/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 lg:px-6 py-20 lg:py-32 flex flex-col items-start">
        <div className="inline-flex items-center gap-2 bg-blue-500/20 border border-blue-500/40 text-blue-400 text-xs lg:text-sm font-semibold px-3 lg:px-4 py-1.5 lg:py-2 rounded-full mb-4 lg:mb-6">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-24-hours-fill text-sm" />
          </span>
          서울 · 경기 · 수도권 전지역 24시간 즉시출동
        </div>

        <h1 className="text-3xl lg:text-5xl xl:text-6xl font-black text-white leading-tight mb-3 lg:mb-4">
          진단부터 완벽복구까지<br />
          <span className="text-white">한번에 끝내는, </span><span className="text-blue-400">원스톱해결</span>
        </h1>

        <p className="text-base lg:text-xl text-zinc-300 mb-2 leading-relaxed max-w-xl">
          10년 이상의 경력 전문가와 최신 장비로<br />
          <strong className="text-white">정확한 누수 탐지 · 신속한 보수</strong>를 보장합니다.
        </p>
        <p className="text-zinc-400 mb-7 lg:mb-10 text-sm lg:text-base">연중무휴 · 야간 · 공휴일 출동 가능 · 무료 사전 상담</p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 lg:gap-4 w-full">
          <a
            href="tel:010-2684-4892"
            className="inline-flex items-center justify-center gap-2 lg:gap-3 bg-blue-500 hover:bg-blue-400 text-white text-base lg:text-lg font-bold px-6 lg:px-8 py-3.5 lg:py-4 rounded-full shadow-xl transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <span className="w-5 lg:w-6 h-5 lg:h-6 flex items-center justify-center">
              <i className="ri-phone-fill text-lg lg:text-xl" />
            </span>
            010-2684-4892 지금 전화하기
          </a>
          <button
            onClick={() => scrollTo("#estimate")}
            className="inline-flex items-center justify-center gap-2 lg:gap-3 bg-white/10 hover:bg-white/20 border border-white/30 text-white text-base lg:text-lg font-bold px-6 lg:px-8 py-3.5 lg:py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            <span className="w-5 lg:w-6 h-5 lg:h-6 flex items-center justify-center">
              <i className="ri-file-list-3-line text-lg lg:text-xl" />
            </span>
            무료 견적 요청
          </button>
        </div>

        {/* Stats */}
        <div className="mt-8 lg:mt-14 grid grid-cols-3 gap-3 lg:gap-6">
          {[
            { num: "10년+", label: "전문 경력" },
            { num: "24시", label: "연중무휴 출동" },
            { num: "100%", label: "고객 만족 보장" },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-xl lg:text-3xl font-black text-blue-400">{s.num}</div>
              <div className="text-zinc-400 text-xs lg:text-sm mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-zinc-400 animate-bounce">
        <span className="text-xs">스크롤</span>
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line" />
        </span>
      </div>
    </section>
  );
}
